// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "confirm-249Gt";
var _3 = "cancel-1s_ms";
export { _1 as "__esModule", _2 as "confirm", _3 as "cancel" }
export default { "__esModule": _1, "confirm": _2, "cancel": _3 }
